import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from './axiosBasedQuery';

import { HTTP_METHODS, buildQueryString } from '../../utils/handler';
import { COMPLAIN_REQUEST } from '../../utils/constant/routeURL';
import { API_BASE_URL } from '../../config';

const { GET, POST, DELETE, PUT } = HTTP_METHODS;
const { GET_COMPLAINS, POST_COMPLAIN, DELETE_COMPLAIN, PUT_COMPLAIN } = COMPLAIN_REQUEST;

export const complainApi = createApi({
  reducerPath: 'complainApi',

  baseQuery: axiosBaseQuery({
    baseUrl: API_BASE_URL,
    credentials: true
  }),

  tagTypes: ['Complains'],

  endpoints: (builder) => ({
    getComplains: builder.query({
      query: (data) => ({ url: `${GET_COMPLAINS}${buildQueryString(data)}`, method: GET }),
      providesTags: ['Complains']
    }),
    addComplain: builder.mutation({
      query: (data) => ({ url: POST_COMPLAIN, method: POST, data }),
      invalidatesTags: ['Complains']
    }),
    deleteComplain: builder.mutation({
      query: (id) => ({
        url: `${DELETE_COMPLAIN}/${id}`,
        method: DELETE
      }),
      invalidatesTags: ['Complains']
    }),
    editComplain: builder.mutation({
      query: (data) => ({
        url: `${PUT_COMPLAIN}/${data?.id}`,
        method: PUT,
        data: data.data
      }),
      invalidatesTags: ['Complains']
    })
  })
});

export const {
  useGetComplainsQuery,
  useAddComplainMutation,
  useEditComplainMutation,
  useDeleteComplainMutation
} = complainApi;
